import React, { useState, useEffect } from 'react';
import classes from './HalfWidth.module.scss';
import renderHTML from 'react-render-html';
import globalJSON from '../../../../../data/global';
import { getFileName } from 'helpers/FileCaching';
import { Link  } from "react-router-dom";
const globalImages = require.context('images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);
const latestThumbnails = require.context('images/components/Latest', true, /.*\.(gif|png|jpe?g|svg)$/i);

function HalfWidth(props) {

    let overlay;
    let content = props.content;

    const showOverlay = content.map((item, index) => {
       if(item.overlay !== '' && item.overlay === 'true'){
            overlay = <div className={`overlay_title`}></div>
        }
    });

    function onHalfWidthClick(event){
		window.gtag('event', "Latest article selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "promo article clicked "+ event,
			'value':10
        });
        
    }

    return (
        <section className={`${classes.HalfWidth}`}>
            <div className={`row no-gutters `}>
                <div className={`${classes.HalfWidth__wrap}`}>
                
                            {content.map((item, index) => (
                                item.externalUrl ? <div  key={index} className={`${classes.HalfWidth__promos}`}>
                                                        <a key={index} className={`${classes.HalfWidth__link}`} href={item.externalUrl} key={index} target='_blank' rel="noopener noreferrer"
                                                                onClick={() => onHalfWidthClick(item.externalUrl)}>
                                                                        {/* {elements}        */}
                                                                        
                                                            <div className={`black_arrow_btn_hover remove-img-color-hero smooth`}>
                                                                <div className={`${classes.HalfWidth__image_container} remove-img-element-hero`}>
                                                                    <img className={`${classes.HalfWidth__image}`} alt={content.thumbnailTitle} src={getFileName(latestThumbnails, item.thumbnail)}></img>
                                                                    {overlay} 
                                                                </div>
                                                                <div className={`row`}>
                                                                    <div className={classes.HalfWidth__content_container}>
                                                                        <div className={`col-9 col-lg-10`}>
                                                                            <p className={`subtitle_white_global`}>{renderHTML(item.subtitle)}</p>
                                                                            <h3 className={classes.HalfWidth__title}>{renderHTML(item.title)}</h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className={classes.HalfWidth__btn_container}>
                                                                        <img className={`black_arrow_btn`} src={getFileName(globalImages, 'arrow_right.svg')} alt={`arrow right`} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                        
                            : item.internalUrl ? <div key={index} className={`${classes.HalfWidth__promos}`}>
                                                    <Link className={`${classes.HalfWidth__link}`} to={process.env.PUBLIC_URL+item.internalUrl}
                                                    onClick={() => onHalfWidthClick(item.internalUrl)}>
                                                        {/* {elements} */}
                                                        <div className={`black_arrow_btn_hover remove-img-color-hero smooth`}>
                                                            <div className={`${classes.HalfWidth__image_container} remove-img-element-hero`}>
                                                                <img className={`${classes.HalfWidth__image}`} alt={content.thumbnailTitle} src={getFileName(latestThumbnails, item.thumbnail)}></img>
                                                                {overlay} 
                                                            </div>
                                                            <div className={`row`}>
                                                                <div className={classes.HalfWidth__content_container}>
                                                                    <div className={`col-9 col-lg-10`}>
                                                                        <p className={`subtitle_white_global`}>{renderHTML(item.subtitle)}</p>
                                                                        <h3 className={classes.HalfWidth__title}>{renderHTML(item.title)}</h3>
                                                                    </div>
                                                                </div>
                                                                <div className={classes.HalfWidth__btn_container}>
                                                                    <img className={`black_arrow_btn`} src={getFileName(globalImages, 'arrow_right.svg')} alt={`arrow right`} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link> 
                                                </div>
                                            
                            : null
                                                        
                        ))

                    }
      
                </div>
            </div>
      
        </section>
    )

}

export default HalfWidth;